function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SwazilandFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_1238",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_1238)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3H24V21H0V3Z",
      fill: "#3D58DB"
    }), /*#__PURE__*/_jsx("path", {
      d: "M0 7H-0.5V7.5V16.5V17H0H24H24.5V16.5V7.5V7H24H0Z",
      fill: "#C51918",
      stroke: "#FFD018"
    }), /*#__PURE__*/_jsx("path", {
      d: "M5.36199 9.99828C5.27203 9.99828 5.1991 9.79488 5.1991 9.54397C5.1991 9.29306 5.27203 9.08966 5.36199 9.08966H18.4201C18.51 9.08966 18.583 9.29306 18.583 9.54397C18.583 9.79488 18.51 9.99828 18.4201 9.99828H5.36199Z",
      fill: "#FFD018"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.0714 9.45166L18.8297 8.48431L20.1714 9.45166L18.8297 10.4444L18.0714 9.45166Z",
      fill: "#F7FCFF"
    }), /*#__PURE__*/_jsx("path", {
      d: "M5.36199 12.9983C5.27203 12.9983 5.1991 12.7949 5.1991 12.544C5.1991 12.2931 5.27203 12.0897 5.36199 12.0897H18.4201C18.51 12.0897 18.583 12.2931 18.583 12.544C18.583 12.7949 18.51 12.9983 18.4201 12.9983H5.36199Z",
      fill: "#FFD018"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.0714 12.4517L18.8297 11.4843L20.1714 12.4517L18.8297 13.4444L18.0714 12.4517Z",
      fill: "#F7FCFF"
    }), /*#__PURE__*/_jsx("path", {
      d: "M3.25912 14.8663C3.1385 14.8663 3.04071 14.6354 3.04071 14.3505C3.04071 14.0656 3.1385 13.8346 3.25912 13.8346H20.7673C20.8879 13.8346 20.9857 14.0656 20.9857 14.3505C20.9857 14.6354 20.8879 14.8663 20.7673 14.8663H3.25912Z",
      fill: "#FFD018"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.61298 12.0395C6.61298 12.0395 8.74399 7.55453 11.7919 7.55453C14.8399 7.55453 17.0425 12.0395 17.0425 12.0395C17.0425 12.0395 14.3529 16.4656 11.8278 16.4656C9.30259 16.4656 6.61298 12.0395 6.61298 12.0395Z",
      fill: "#F7FCFF"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_1238",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "6",
      y: "7",
      width: "12",
      height: "10",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.61298 12.0395C6.61298 12.0395 8.74399 7.55453 11.7919 7.55453C14.8399 7.55453 17.0425 12.0395 17.0425 12.0395C17.0425 12.0395 14.3529 16.4656 11.8278 16.4656C9.30259 16.4656 6.61298 12.0395 6.61298 12.0395Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_1238)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.9432 7.2601C11.9432 7.2601 11.2478 8.10475 11.4796 8.91019C11.7114 9.71563 12.2515 9.63056 12.2515 10.3399C12.2515 11.0492 12.002 11.7726 12.2515 11.7726C12.501 11.7726 12.5875 12.2621 12.3595 12.5939C12.1314 12.9258 11.9297 12.936 11.9432 13.4761C11.9567 14.0162 13.1373 14.5463 12.5654 14.5463C11.9935 14.5463 11.2398 15.1014 11.4796 15.1014C11.7194 15.1014 12.9741 15.5339 12.9741 16.1014C12.9741 16.669 12.9741 17.1232 12.9741 17.1232H6.42847V7.2601H11.9432Z",
        fill: "#272727"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.86424 10.4423H8.53845V11.7692H8.86424V10.4423ZM9.82533 10.4423H9.49954V11.7692H9.82533V10.4423ZM9.01899 10.4423H9.34479V11.7692H9.01899V10.4423ZM10.3059 10.4423H9.98008V11.7692H10.3059V10.4423ZM10.4606 10.4423H10.7864V11.7692H10.4606V10.4423ZM11.267 10.4423H10.9412V11.7692H11.267V10.4423ZM8.53845 12.3462H8.86424V13.6731H8.53845V12.3462ZM9.82533 12.3462H9.49954V13.6731H9.82533V12.3462ZM9.01899 12.3462H9.34479V13.6731H9.01899V12.3462ZM10.3059 12.3462H9.98008V13.6731H10.3059V12.3462ZM10.4606 12.3462H10.7864V13.6731H10.4606V12.3462ZM11.267 12.3462H10.9412V13.6731H11.267V12.3462Z",
        fill: "#F7FCFF"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.733 10.4423H12.4072V11.7692H12.733V10.4423ZM13.6941 10.4423H13.3683V11.7692H13.6941V10.4423ZM12.8878 10.4423H13.2136V11.7692H12.8878V10.4423ZM14.1746 10.4423H13.8489V11.7692H14.1746V10.4423ZM14.3294 10.4423H14.6552V11.7692H14.3294V10.4423ZM15.1357 10.4423H14.8099V11.7692H15.1357V10.4423ZM12.4072 12.3462H12.733V13.6731H12.4072V12.3462ZM13.6941 12.3462H13.3683V13.6731H13.6941V12.3462ZM12.8878 12.3462H13.2136V13.6731H12.8878V12.3462ZM14.1746 12.3462H13.8489V13.6731H14.1746V12.3462ZM14.3294 12.3462H14.6552V13.6731H14.3294V12.3462ZM15.1357 12.3462H14.8099V13.6731H15.1357V12.3462Z",
        fill: "#272727"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.92373 8.30371C9.46736 8.4451 9.25851 9.64197 9.30952 9.93126C9.36053 10.2206 9.51538 9.89496 9.51538 9.89496C9.51538 9.89496 9.83116 10.5813 9.86372 10.7659C9.89628 10.9506 10.0626 10.4868 10.0626 10.4868C10.0626 10.4868 10.6103 10.8642 10.6845 11.2846C10.7586 11.7051 10.8701 10.8035 10.8701 10.8035C10.8701 10.8035 10.9942 10.7816 10.9942 10.7816C10.9942 10.7816 10.9157 10.3364 10.9157 10.3364L11.1523 10.5387L11.0793 10.1247C11.0793 10.1247 11.2575 10.3576 11.2123 10.1013C11.1671 9.84491 11.1419 9.7018 11.1419 9.7018L11.0801 9.35144L11.3143 9.31014C11.3143 9.31014 10.3801 8.16231 9.92373 8.30371Z",
        fill: "#3D58DB"
      })]
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.5662 13.2719C19.0922 13.3319 18.6787 14.4743 18.6787 14.7681C18.6787 15.0618 18.8877 14.7681 18.8877 14.7681C18.8877 14.7681 19.0795 15.4988 19.0795 15.6863C19.0795 15.8738 19.3239 15.4459 19.3239 15.4459C19.3239 15.4459 19.7977 15.9127 19.7977 16.3396C19.7977 16.7666 20.0641 15.898 20.0641 15.898C20.0641 15.898 20.1901 15.898 20.1901 15.898C20.1901 15.898 20.1901 15.4459 20.1901 15.4459L20.388 15.6863V15.2659C20.388 15.2659 20.5231 15.5262 20.5231 15.2659C20.5231 15.0056 20.5231 14.8603 20.5231 14.8603V14.5045H20.7609C20.7609 14.5045 20.0402 13.2119 19.5662 13.2719Z",
      fill: "#3D58DB"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.19466 13.0988C4.66865 13.1588 5.08215 14.3012 5.08215 14.595C5.08215 14.8887 4.87312 14.595 4.87312 14.595C4.87312 14.595 4.68132 15.3257 4.68132 15.5132C4.68132 15.7007 4.43701 15.2729 4.43701 15.2729C4.43701 15.2729 3.96312 15.7396 3.96312 16.1665C3.96312 16.5935 3.69674 15.7249 3.69674 15.7249C3.69674 15.7249 3.57075 15.7249 3.57075 15.7249C3.57075 15.7249 3.57075 15.2729 3.57075 15.2729L3.37286 15.5132V15.0928C3.37286 15.0928 3.2378 15.3531 3.2378 15.0928C3.2378 14.8325 3.2378 14.6872 3.2378 14.6872V14.3314H2.99998C2.99998 14.3314 3.72066 13.0388 4.19466 13.0988Z",
      fill: "#3D58DB"
    })]
  })]
}));
//# sourceMappingURL=Swaziland.js.map